import { Route, Routes } from 'react-router-dom';
import UserProvider from '../user-management/context/UserProvider';
import { IQueryParams } from '../Dashboard';
import { HotelsDashboard } from './HotelsDashboard';
import { HotelOrderView } from './HotelsDashboard/hotelOrderView';
import HotelProvider from './context/HotelProvider';

export const HotelsManagement = (props: IQueryParams) => {
  return (
    <UserProvider>
      {/**
       * NOTE: OrderProvider is used to provide order context to all it's child
       * components...
       */}
      <HotelProvider data={props}>
        <Routes>
          <Route path='/' element={<HotelsDashboard data={props} />} />
          <Route path=':id/*' element={<HotelOrderView />} />
          {/* <Route index element={<Navigate to={`/apps/flights`} />} /> */}
        </Routes>
      </HotelProvider>
    </UserProvider>
  );
};
